module.exports = __webpack_public_path__ + "static/media/cy.bb01eb74.svg";